import { BULK_UPLOAD, UPLOAD_BULK_TRANSACTIONS } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";
import { FormDataRestClient } from "../../api/rest_interceptor";

const bulkUploadMiddleware = store => next => async action => {
    let formData = action.payload;

    switch (action.type) {
        case BULK_UPLOAD:

            try {
                let stateProperties = store.getState().properties;
                let stateUnits = store.getState().units;
                let stateTenants = store.getState().tenants;

                await FormDataRestClient.post('api/file_uploads/upload_bulk',
                    formData).then((response) => {
                        if (response.errors) {
                            action = updateActionErrors(action, response.errors);
                        } else {
                            //update properties
                            let properties = { ...stateProperties };
                            let propertyIDs = [];

                            response.data.created_properties.map((property) => {
                                properties[property.id] = {
                                    propertyId: property.id,
                                    propertyName: property.name,
                                    numUnits: property.unit_count,
                                    vacancies: property.vacancies,
                                    city: property.city,
                                    address: property.address_street,
                                    units: {}
                                }
                            })

                            //update units

                            let units = { ...stateUnits };
                            response.data.created_units.map((unit) => {
                                units[unit.id] = {
                                    propertyId: unit.property,
                                    unitName: unit.unit_name,
                                    unitId: unit.id,
                                    rentAmount: unit.rent_amount,
                                    occupied: unit.occupied
                                };
                                // update units in properties state
                                properties[unit.property]["units"][unit.id] = {}
                            })

                            //update tenants

                            let tenants = { ...stateTenants };
                            response.data.created_tenants.map((tenant) => {
                                tenants[tenant.tenantId] = {
                                    tenantId: tenant.tenantId,
                                    unitId: tenant.unit,
                                    propertyId: tenant.propertyId,
                                    firstName: tenant.firstName,
                                    lastName: tenant.lastName,
                                    email: tenant.email,
                                    phoneNumber: tenant.phoneNumber,
                                    accountBalance: tenant.accountBalance
                                };
                                // update tenants in properties state
                                properties[tenant.propertyId]["units"][tenant.unit][tenant.tenantId] = tenant.tenantId;
                            })

                            let initialData = { properties, units, tenants };

                            action = {
                                ...action,
                                payload: initialData
                            };
                        }

                    }
                    )

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case UPLOAD_BULK_TRANSACTIONS:

            try {
                await FormDataRestClient.post('api/file_uploads/upload_bulk_transactions',
                    formData).then((response) => {
                        if (response.errors) {
                            action = updateActionErrors(action, response.errors);
                        } else if(!response.data.Success){
                            action = updateActionErrors(action, response.data.Message);
                        }
                    }
                    )

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

    }

    return next(action);
};

export {
    bulkUploadMiddleware
}